import { useState } from "react";
import VarianceReportDetails from "./FinalKitchenGIVarianceReportDetails";
import FilterData from "../FilterData";

const FinalKitchenGIVarianceReport = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [params,setParams] = useState()
  const handleClick = (): void => {
      setOpen(true);
  };  
  const handleFilterChange = (): void => {
    setOpen(false);
  };  
  const handleParamsChange = (values:any): void => {
    setParams(values)
  }
  return (
    <div className="content-wrapper">
      <h1 className="flex align-items-center">
        Cilantro Final Kitchen Indent vs SAP GI Variance Report
      </h1>
      <FilterData handleClick={handleClick} handleFilterChange={handleFilterChange} handleParamsChange={handleParamsChange}/>
      {open && 
        <VarianceReportDetails params={params}/>
      }      
    </div>    
  );
};

export default FinalKitchenGIVarianceReport;
